import { post } from "../../service/api";

export const CheckHistoryPaid = async (historyId) => {
  try {
    const response = await post(`/negdi/history/${historyId}/check`);
    if (response && response.data) return response;
    else return null;
  } catch (error) {
    console.error("Error CheckHistoryPaid:", error);
    return null;
  }
};
